<template>
  <b-row>
    <div class="card" style="width: 99.5%;">
      <b-row no-gutters>
        <b-col md="6">
          <div class="card-body">
            <h5 class="card-title">{{metadata.label}}</h5>
            <!-- <p class="card-text"></p> -->
            <template v-for="(item, index) in metadata.children">
              <FormComponent :metadata='item' :dbfield='index' :key='"comp_"+index' v-model="groupvalue[index]"
                  v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="isSearch"
                  v-on:updatex="updatex"/>
            </template>
          </div>
        </b-col>
        <b-col md="6">
          <div class="centerimg"><img class="card-img" :src="areaImage" alt="Card image cap"></div>
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import areaImage from '@/assets/remosion-masa.jpg'

export default {
  name: 'FormComponentLandslide',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      groupvalue: {},
      areaImage
    }
  },
  mounted () {
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  watch: {
    value: function (val) {
      /* for (var i in val) {
        this.$set(this.groupvalue, i, val[i])
      } */
      for (var item in this.metadata.children) {
        if (!(item in val)) {
          val.item = null
        }
      }
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
    }
  }
}
</script>

<style>
</style>
